import { gql } from '@apollo/client';

export const GET_GLOBAL_SETTINGS_LIST = gql`
  query ChatbotGlobalSettings($params: FindGlobalSettingListInput!) {
    chatbotGlobalSettings(params: $params) {
      success
      message
      errors
      data {
        settings {
          id
          settingKey
          settingValue
          settingType
          description
          createdAt
          createdBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_GLOBAL_SETTING = gql`
  query ChatBotGlobalSetting($params: FindGlobalSettingInput!) {
    chatBotGlobalSetting(params: $params) {
      success
      message
      errors
      data {
        id
        settingKey
        settingValue
        settingType
        description
        createdAt
        createdBy
      }
    }
  }
`;
